import { useState } from "react"
import { ImageIcon } from "lucide-react"

interface StyleThumbnailProps {
  src: string
  updatedAt: string
  alt: string
  className?: string
}

/** 썸네일 URL에 캐시 버스팅 파라미터 추가 */
function withCacheBusting(url: string, updatedAt: string): string {
  const timestamp = new Date(updatedAt).getTime()
  return `${url}?v=${timestamp}`
}

export function StyleThumbnail({ src, updatedAt, alt, className = "" }: StyleThumbnailProps) {
  const [errorKey, setErrorKey] = useState("")
  const currentKey = `${src}:${updatedAt}`
  const hasError = errorKey === currentKey

  if (hasError) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 ${className}`}>
        <ImageIcon className="w-6 h-6 text-slate-400" />
      </div>
    )
  }

  return (
    <img
      src={withCacheBusting(src, updatedAt)}
      alt={alt}
      className={`object-cover ${className}`}
      onError={() => setErrorKey(currentKey)}
    />
  )
}
